import type { Transition, Variants } from 'framer-motion';

/* ── Easings ─────────────────────────────────────────────────────── */
export const ease = [0.2, 0.7, 0.2, 1] as const;
export const easeOut = [0.2, 0.7, 0.2, 1] as const;
export const easePwa = [0.2, 0.7, 0.2, 1] as const;

/* ── Springs ─────────────────────────────────────────────────────── */
export const spring: Transition = {
  type: 'spring',
  stiffness: 380,
  damping: 30,
  mass: 0.8,
};

export const springSoft: Transition = {
  type: 'spring',
  stiffness: 260,
  damping: 26,
};

/* ── Page transitions ────────────────────────────────────────────── */
export const pageVariants: Variants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.28, ease: easePwa } },
  exit: { opacity: 0, y: -6, transition: { duration: 0.22, ease: easePwa } },
};

export const pageTransitionVariants: Variants = pageVariants;

/* ── Lists ───────────────────────────────────────────────────────── */
export const listVariants: Variants = {
  animate: { transition: { staggerChildren: 0.06, delayChildren: 0.05 } },
};

export const itemVariants: Variants = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.3, ease } },
  exit: { opacity: 0, scale: 0.96, transition: { duration: 0.18, ease } },
};

/* ── Sheets / backdrop ───────────────────────────────────────────── */
export const sheetVariants: Variants = {
  initial: { y: '100%' },
  animate: { y: 0, transition: spring },
  exit: { y: '100%', transition: { duration: 0.28, ease } },
};

export const backdropVariants: Variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.24 } },
  exit: { opacity: 0, transition: { duration: 0.2 } },
};

/* ── Tap scale ───────────────────────────────────────────────────── */
export const tapScale = {
  whileTap: { scale: 0.97 },
  transition: spring,
} as const;

/* ── Reveal ──────────────────────────────────────────────────────── */
export const revealVariants: Variants = {
  initial: { opacity: 0, y: 28 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.7, ease } },
};

/* ── Helper para prefers-reduced-motion ──────────────────────────── */
export function motionWhen<P extends Record<string, unknown>>(
  reduce: boolean | null,
  props: P,
): P | Record<string, never> {
  return reduce ? {} : props;
}

/* ── Legacy aliases ──────────────────────────────────────────────── */
export const modalVariants: Variants = {
  initial: { opacity: 0, scale: 0.97 },
  animate: {
    opacity: 1,
    scale: 1,
    transition: { type: 'spring', damping: 25, stiffness: 320 },
  },
  exit: { opacity: 0, scale: 0.97, transition: { duration: 0.1 } },
};

export const staggerChildren = (delay = 0.06): Variants => ({
  animate: { transition: { staggerChildren: delay } },
});

export const checkmarkDraw: Variants = {
  initial: { pathLength: 0, opacity: 0 },
  animate: {
    pathLength: 1,
    opacity: 1,
    transition: {
      pathLength: { duration: 0.3, ease },
      opacity: { duration: 0.1 },
    },
  },
};
